import { render } from "./endpoint.vue?vue&type=template&id=36decdf0"
import script from "./endpoint.vue?vue&type=script&lang=js"
export * from "./endpoint.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__